type WorkspaceRef = { orgRef: string; workspace: string };

type RememberedChat = { sessionId: string; chatCategory: string };

const workspaceKeyOf = ({ orgRef, workspace }: WorkspaceRef) => JSON.stringify([orgRef, workspace]);

const categoryKeyOf = (workspaceRef: WorkspaceRef, chatCategory: string) =>
  JSON.stringify([workspaceKeyOf(workspaceRef), chatCategory]);

export const createRememberedSetupChats = (initial?: WorkspaceRef & RememberedChat) => {
  const byCategory = new Map<string, string>();
  const lastByWorkspace = new Map<string, RememberedChat>();
  const remember = (workspaceRef: WorkspaceRef, { sessionId, chatCategory }: RememberedChat) => {
    byCategory.set(categoryKeyOf(workspaceRef, chatCategory), sessionId);
    lastByWorkspace.set(workspaceKeyOf(workspaceRef), { sessionId, chatCategory });
  };
  const forget = (workspaceRef: WorkspaceRef, chatCategory: string) => {
    const categoryKey = categoryKeyOf(workspaceRef, chatCategory);
    const sessionId = byCategory.get(categoryKey);
    byCategory.delete(categoryKey);
    const workspaceKey = workspaceKeyOf(workspaceRef);
    if (sessionId && lastByWorkspace.get(workspaceKey)?.sessionId === sessionId)
      lastByWorkspace.delete(workspaceKey);
  };
  if (initial) remember(initial, initial);
  return {
    remember,
    forget,
    ofCategory: (workspaceRef: WorkspaceRef, chatCategory: string) =>
      byCategory.get(categoryKeyOf(workspaceRef, chatCategory)),
    lastOf: (workspaceRef: WorkspaceRef) => lastByWorkspace.get(workspaceKeyOf(workspaceRef)),
  };
};
